import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateBlog($data: CreateBlogInput!) {
    createBlog(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createBlog: {
    id: number;
  };
}
